export default {
    company: {
        name: "Yibin Paper"
    },
    nav: {
        home: "Home",
        about: "About",
        products: "Products",
        contact: "Contact",
        sustainability: "Sustainability",
        technology: "Technology"
    },
    banner: {
        title: "Bamboo Elegance · Green Future",
        subtitle: "Inheriting Thousand-Year Paper Making Craft, Leading New Standards in Bamboo Pulp Paper"
    },
    products: {
        subtitle: "Premium Bamboo Pulp Paper Products for Diverse Needs",
        description: "We provide comprehensive paper product solutions, from base paper to finished products, meeting all your needs",
        viewDetails: "View Details",
        categories: {
            title: "Product Series",
            subtitle: "Bamboo Pulp Paper Products, Leading Green Consumption Trends"
        },
        advantages: {
            title: "Product Advantages",
            subtitle: "Renewing Life with Bamboo"
        },
        applications: {
            title: "Applications",
            subtitle: "Widely Used in Daily Life and Various Industries"
        },
        items: {
            livingPaper: {
                title: "Living Paper Base",
                description: "High-quality living paper base series"
            },
            foodPaper: {
                title: "Food Packaging Base",
                description: "Safe and eco-friendly food packaging base"
            },
            handTowel: {
                title: "Hand Towel Series",
                description: "Strong absorption, durable"
            },
            kitchenTissue: {
                title: "Kitchen Tissue Series",
                description: "Strong absorption, durable"
            },
            boxTissue: {
                title: "Box Tissue Series",
                description: "Easy to pull, economical"
            },
            rollPaper: {
                title: "Roll Paper Series",
                description: "Soft and comfortable, strong absorption"
            },
            softTissue: {
                title: "Soft Tissue Series",
                description: "Soft and comfortable, easy to pull"
            },
            pocketTissue: {
                title: "Pocket Tissue",
                description: "Compact and portable, ready to use"
            },
            barTowel: {
                title: "Bar Towel Series",
                description: "Strong absorption, durable"
            },
            smallRoll: {
                title: "Small Roll Series",
                description: "Compact and portable, easy to use"
            }
        },
        cta: {
            title: "Need Custom Product Solutions?",
            description: "We can provide professional bamboo pulp paper product customization services based on your needs",
            buttonText: "Contact Us"
        },
        detail: {
            features: 'Product Features',
            contactUs: 'Contact Us',
            specifications: 'Product Specifications',
            usageScenarios: 'Usage Scenarios',
            relatedProducts: 'Related Products',
            cta: {
                title: 'Need More Product Information?',
                description: 'Our product consultants are ready to provide professional consultation and customized solutions',
                buttonText: 'Contact Us'
            }
        }
    },
    footer: {
        contact: "Contact Us",
        address: "Address: Yibin City, Sichuan Province",
        phone: "Tel: 0831-12345678",
        email: "Email: info@yibinpaper.com",
        quickLinks: "Quick Links",
        moreInfo: "More Information",
        news: "News",
        careers: "Careers",
        followUs: "Follow Us",
        wechat: "WeChat Official Account: Yibin Paper",
        rights: "All Rights Reserved",
        slogan: "Bamboo Pulp Paper Making, Green Innovation"
    },
    advantages: {
        title: "Our Advantages",
        subtitle: "Bamboo Pulp Paper Making, Eco-friendly Technology, Excellent Quality",
        items: {
            experience: {
                title: "Rich Industry Experience",
                description: "80 years of technical expertise, complete pulp and paper making industry chain, providing solid technical support for green low-carbon bio-based material transformation."
            },
            production: {
                title: "Mature Production System",
                description: "Complete production facilities and automated production lines, capable of quick response to customer needs, achieving low-cost and high-efficiency mass production."
            },
            innovation: {
                title: "Industry-Academia-Research Innovation",
                description: "Joint laboratories with universities and research institutions, focusing on low-carbon processes and renewable materials R&D, accelerating the industrialization of cutting-edge technologies like bio-based materials."
            },
            certification: {
                title: "Full-chain Green Certification",
                description: "From raw material procurement to product manufacturing, certified by FSC, medical-grade products, and health safety products, enhancing product competitiveness."
            }
        }
    },
    about: {
        companyProfile: "Company Profile",
        established: "Established in 1944",
        formerName: `Formerly known as "China Paper Factory"`,
        firstNewsprint: "Birthplace of China's first machine-made newsprint",
        listed: "Listed on Shanghai Stock Exchange in 1997 (Stock Code: 600793)",
        firstListed: "First listed company in China's paper industry",
        firstYibinListed: "First listed company in Yibin City",
        wuliangyeSubsidiary: "Became a subsidiary of Wuliangye Group in January 2018",
        capacity: "Production Capacity",
        mainCapacity: "Total pulp and paper capacity of 540,000 tons/year at headquarters",
        managedCapacity: "Total pulp and paper capacity of 120,000 tons/year at managed companies",
        newMaterialCapacity: "New material corrugated box capacity of 100 million square meters/year",
        bambooMoldingCapacity: "New material bamboo pulp molding capacity of 6,600 tons/year",
        celluloseCapacity: "Cellulose acetate capacity of 30,000 tons/year",
        historyTitle: "Development History",
        historySubtitle: "Over 70 years of dedication, building a bamboo pulp paper brand",
        historyItems: {
            "1944": "China Paper Factory established, marking the beginning of China's paper industry",
            "1945": "Successfully produced China's first 100% mechanical wood pulp newsprint",
            "1950": `Renamed from "China Paper Factory" to "Yibin Paper Factory"`,
            "1961": "Visit by Chairman Zhu De",
            "1966": "Visit by Marshal Peng Dehuai",
            "1988": "Pilot shareholding system reform, established 'Yibin Paper Co., Ltd.'",
            "1997": "Listed on Shanghai Stock Exchange",
            "2012": "Groundbreaking ceremony for Yibin Paper's overall relocation",
            "2015": "New food packaging paper production line completed and put into operation",
            "2018_1": "New tissue paper production line completed and put into operation",
            "2018_2": "Became a subsidiary of Wuliangye Group",
            "2025": "Embarking on a strategic development path from traditional paper industry to a comprehensive green carbon special bio-based materials industry group"
        },
        futureDevelopment: "Future Development",
        future: {
            point1: "Comprehensive focus on development goals",
            point2: "Fully leverage bamboo resource advantages",
            point3: "Accelerate transformation to specialized, high-tech, high-value-added businesses",
            point4: "Build world-class specialized champions in paper product segments"
        },
        coreValues: "Corporate Philosophy",
        coreValuesSubtitle: "Bamboo as bone, paper as soul, green innovation drives development",
        values: {
            mission: "Corporate Mission",
            missionLine1: "Based on new biological materials",
            missionLine2: "Creating a green carbon beautiful world",
            vision: "Corporate Vision",
            visionLine1: "Building a comprehensive green carbon special bio-based",
            visionLine2: "materials industry group",
            coreValues: "Core Values",
            coreValuesLine1: "Quality first, innovation-driven",
            coreValuesLine2: "Green development, win-win cooperation",
            philosophy: "Business Philosophy",
            philosophyLine1: "Customer-centric",
            philosophyLine2: "Quality-based, innovation-driven"
        },
        certificationsTitle: "Certifications",
        certificationsSubtitle: "Quality assurance, industry recognition",
        certificationItems: {
            fsc: "International Forest Certification, raw materials from responsibly managed forest resources",
            iso9001: "International Quality Management System Certification",
            iso14001: "International Environmental Management System Certification",
            medical: "Medical-grade Product Certification",
            medicalDesc: "Medical-grade Product Certification Certificate",
            antibacterial: "Antibacterial Hygiene Certification",
            antibacterialDesc: "Antibacterial Hygiene Certification Certificate",
            safety: "Hygiene and Safety Product Certification",
            safetyDesc: "Hygiene and Safety Product Certification Certificate"
        },
        honorsTitle: "Company Honors",
        honorsSubtitle: "Quality assurance, industry recognition",
        honorItems: {
            greenFactory: "National Green Factory",
            greenFactoryDesc: "Green Manufacturing Benchmark Enterprise title awarded by Ministry of Industry and Information Technology",
            forestryLeader: "National Forestry Key Leading Enterprise",
            forestryLeaderDesc: "Key Leading Enterprise title awarded by National Forestry and Grassland Administration",
            agriculturalProduct: "China Excellent Agricultural Product Enterprise",
            agriculturalProductDesc: "China Excellent Agricultural Product Enterprise Brand",
            lightIndustry: "National Light Industry Advanced Collective",
            lightIndustryDesc: "National Light Industry Advanced Collective",
            bambooExpo: "2025 Bamboo Expo Excellent Organization Award",
            bambooExpoDesc: "2025 Bamboo Expo Excellent Organization Award",
            engineeringCenter: "Paper Engineering Technology Research Center",
            engineeringCenterDesc: "Sichuan Provincial Bamboo Pulp Paper Engineering Technology Research Center"
        },
        productHonorsTitle: "Product Honors",
        productHonorsSubtitle: "Quality assurance, industry recognition",
        productHonorItems: {
            industryExcellence: "Industry Excellence Product",
            neZhaExcellence: "NeZha series won 2025 China Tissue Paper Industry Excellence Product",
            moDiKaExcellence: "MoDiKa series won 2025 China Tissue Paper Industry Excellence Product",
            bambooExpoGold: "Bamboo Expo Gold Award",
            moDiKaGold: "MoDiKa series won 2025 Bamboo Expo Gold Award",
            shanghaiExpoGold: "Shanghai International Bamboo Expo Gold Award",
            jinZhuGold: "JinZhu Natural series won 2020 Shanghai International Bamboo Expo Gold Award",
            quanZhuGold: "QuanZhu packaging paper won 2018 Shanghai International Bamboo Expo Gold Award",
            westernExpoGold: "Western China Forestry Industry Expo Gold Award",
            jinZhuWesternGold: "JinZhu Natural series won 2018 First Western China Forestry Industry Expo Gold Award"
        },
        cta: {
            title: "Join Yibin Paper for a Green Future",
            description: "We look forward to working with you to promote the sustainable development of the bamboo pulp paper industry",
            buttonText: "Contact Us"
        }
    },
    technology: {
        title: 'Technology Innovation',
        subtitle: 'Technology Leadership, Green Innovation, Creating New Industry Standards',
        innovation: {
            title: 'Innovation-Driven Development',
            subtitle: 'Technology Leadership, Green Innovation, Creating New Industry Standards',
            management: {
                title: 'Efficient Innovation Management System',
                content: 'Yibin Paper always regards technological innovation as the core driving force of enterprise development. The company has established a Strategy and Development Committee to coordinate R&D, production, and market sectors, creating an innovation architecture of "Headquarters Technology R&D Department + Production Base" with flexible incentive mechanisms to ensure efficient implementation of technological innovation to industrialization.'
            },
            team: {
                title: 'Professional Team Leading Technological Breakthroughs',
                content: 'Relying on provincial innovation platforms and R&D innovation teams, we maintain close cooperation with multiple renowned universities and research institutions, focusing on low-carbon pulping, bio-based materials, and other cutting-edge fields to carry out R&D projects, providing strong momentum for enterprise innovation and development.'
            },
            results: {
                title: 'Innovation Results Empowering Industry Upgrade',
                content: 'Mastering the entire chain of core technologies in bamboo pulping and papermaking, we continue to make breakthroughs in green pulping, clean production, and comprehensive resource utilization through technological innovation, leading the enterprise\'s transformation and upgrade towards a green, low-carbon bio-based materials industry.'
            }
        },
        core: {
            title: 'Core Technologies',
            subtitle: 'Technology Leadership, Green Innovation',
            tabs: {
                pulping: 'Bamboo Pulping Technology',
                bleaching: 'Circular Economy Core Technology',
                papermaking: 'Green Product Innovation Technology'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: 'Bamboo Pre-treatment Technology System',
                            content: 'Breakthrough in handling high-density, high-silicon content bamboo, developing homogeneous impregnation technology, reducing energy consumption by over 10%.'
                        },
                        {
                            title: 'Low-carbon Clean Pulping Technology',
                            content: 'Combined process of "Deep Delignification-ECF Bleaching", AOX emissions 30% lower than national standards; integrated "Anaerobic+Aerobic+Fenton" water treatment technology, COD emissions 50% lower than national standards.'
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: 'Bamboo Full Component Utilization Technology',
                            content: 'Bamboo cellulose for pulping and papermaking; black liquor lignin combustion for heat recovery, generating 350kWh per ton of pulp; pulping waste converted to bio-fertilizer for natural recycling.'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: 'Functional Bamboo Fiber Products',
                            content: 'Bamboo fiber reinforcement technology increases packaging paper tensile and folding strength by over 50%, providing better product performance; development of self-antibacterial tissue products, utilizing bamboo\'s natural antibacterial components to improve antibacterial efficiency by over 90% under the same conditions.'
                        },
                        {
                            title: 'Bio-based New Materials',
                            content: 'Bamboo fiber products replacing plastic products, reducing carbon footprint by 60%.'
                        }
                    ]
                }
            }
        },
        research: {
            title: 'R&D Center',
            subtitle: 'Focus on R&D, Create Value',
            imageAlt: 'Yibin Paper R&D Center',
            center: {
                title: 'National Enterprise Technology Center',
                content: 'Established in 2003, the R&D Center is the core department of the company\'s technological innovation, dedicated to pulping and papermaking technology research, new product development, and production process optimization. It was recognized as a provincial enterprise technology center in 2009 and 2023. Through integrating talent, technology, and resources, the R&D Center focuses on industry development trends, promotes the transformation of scientific and technological achievements, and provides core competitiveness for the enterprise.'
            },
            cooperation: {
                title: 'Cooperative R&D',
                content: 'The center has established long-term cooperative relationships with Sichuan Agricultural University, South China University of Technology, Beijing Forestry University, Nanjing Forestry University, Chinese Academy of Forestry Sciences, and other universities and research institutions, jointly undertaking national and provincial-level research projects to promote deep integration of industry, academia, and research.'
            }
        },
        patents: {
            title: 'Patents and Achievements',
            subtitle: 'Technology Accumulation, Industry Leadership',
            authorized: {
                title: 'Authorized Patents',
                items: [
                    'A Refined Mixed Bamboo Pulp and Its Preparation Method and Application in Papermaking',
                    'A Refined Bamboo Pulp and Its Preparation Method and Application in Papermaking',
                    'A Black Liquor Gun for Alkali Recovery Furnace',
                    'A Fiber Screening Device'
                ]
            },
            projects: {
                title: 'Research Projects',
                items: [
                    'Research on High Bulk and High Strength Bamboo Pulp Clean Energy Manufacturing and High Strength Packaging Board Technology',
                    'Research on Bamboo Chemical Pulp Purification and High-grade Tissue Paper Technology',
                    'Research and Development of Bamboo-based Pulp Deep Processing Technology',
                    'Research and Development of High-quality Bamboo-based Cellulose Fiber',
                    'Research and Development of Functional Lignin High-value Products'
                ]
            },
            awards: {
                title: 'Technology Awards',
                items: [
                    'Sichuan Provincial Science and Technology Progress First Prize'
                ]
            },
            papers: {
                title: 'Research Papers',
                items: [
                    'Determination of Total Rosin and Aluminum Sulfate Content in Cationic Dispersed Rosin Emulsion',
                    'Trial Production of Natural Food Cardboard with Bamboo Chemical Mechanical Pulp',
                    'Application of Cooking Additives in Full Bamboo DDS Cooking',
                    'A novel process for efficient utilization of bamboo fiber resource in dissolving pulp production by fiber fractionation: Laboratory study and mill trials',
                    'Tandem strategy of photocatalytic preoxidation-ultrasonic cavitation depolymerization for lignin valorization'
                ]
            }
        },
        projects: {
            title: 'Innovation Projects',
            subtitle: 'Leading Future Industry Development',
            items: [
                {
                    title: 'Sichuan Bamboo Industry Chain Key Technology Integration and Demonstration Factory',
                    period: '2019-2022',
                    cooperation: 'Sichuan Agricultural University',
                    desc: 'Integrating bamboo resource chain with industry chain to promote bamboo industry development.'
                },
                {
                    title: 'Yibin Forest and Bamboo Industry High-tech Innovation Platform Construction and Demonstration',
                    period: '2019-2022',
                    cooperation: 'South China University of Technology',
                    desc: 'Breakthroughs in low-sulfur bamboo cooking technology and black liquor high-value utilization technology.'
                },
                {
                    title: 'Research and Development of Bamboo-based Pulp Deep Processing Technology',
                    period: '2022-2024',
                    cooperation: 'Chinese Academy of Forestry Sciences',
                    desc: 'Breaking through key technologies in high-yield bamboo pulping and implementing industrialization to achieve raw material import substitution.'
                },
                {
                    title: 'Research and Development of Functional Lignin High-value Products',
                    period: '2022-2024',
                    cooperation: 'Beijing Forestry University',
                    desc: 'Extracting lignin components from bamboo pulping black liquor to prepare by-products, breaking through black liquor high-value utilization pathways.'
                },
                {
                    title: 'Research on Bamboo Pulp and Paper Integration Key Technologies',
                    period: '2023-2028',
                    cooperation: 'Chinese Academy of Forestry Sciences',
                    desc: 'Key technologies including efficient homogeneous impregnation softening, precise dissociation energy-saving refining, and alkaline hydrogen peroxide activation bleaching.'
                },
                {
                    title: 'Smart Bamboo Industry Key Technology Research and Integration Demonstration',
                    period: '2024-2027',
                    cooperation: 'Nanjing Forestry University',
                    desc: 'Conducting research on key technical challenges in clean manufacturing and comprehensive resource utilization for bamboo pulp and paper enterprises.'
                }
            ]
        },
        cta: {
            title: 'Explore the Future of Bamboo Pulp and Paper Together',
            subtitle: 'Welcome partners interested in bamboo pulp and paper technology innovation to contact us and jointly promote industry development',
            button: 'Contact Us'
        }
    },
    sustainability: {
        title: 'Sustainable Development',
        subtitle: 'Building a Green Future with Bamboo as the Foundation and Innovation as the Driver',
        vision: {
            title: 'Sustainability Vision',
            content: 'Building a Green Future with Bamboo as the Foundation and Innovation as the Driver',
            imageAlt: 'Yibin Paper Sustainability Vision',
            intro1: 'As an innovator in the bamboo pulp and paper industry,',
            intro2: 'Yibin Paper adheres to the core of "efficient bamboo resource utilization + low-carbon technology", promoting the transformation of traditional industries towards greening, high-value, and circular development.',
            intro3: 'We are committed to:',
            items: {
                circular: {
                    title: 'Green and Low-Carbon, Leading Circular Economy',
                    content: 'Leveraging bamboo\'s renewable and fast-growing carbon sequestration properties, we build a complete industrial chain from "bamboo resources—clean pulping—bio-based materials—low-carbon products", achieving "zero waste, full utilization" and supporting the 30/60 carbon neutrality goals.'
                },
                innovation: {
                    title: 'Technological Innovation, Driving High-Value Transformation',
                    content: 'Breaking through bamboo fiber high-value utilization technology, developing degradable packaging, bio-based composite materials and other plastic-alternative products, reducing carbon footprint throughout the lifecycle.'
                },
                rural: {
                    title: 'Ecological Win-Win, Empowering Rural Revitalization',
                    content: 'Through the "bamboo forest base + green factory + community symbiosis" model, promoting bamboo forest carbon sink income, driving coordinated development of upstream and downstream industrial chains, achieving unity of environmental, economic and social benefits.'
                },
                cooperation: {
                    title: 'Open Collaboration, Building a Sustainable Future Together',
                    content: 'Working with research institutions and industry chain partners to promote bamboo-based material standards and technology application, making "bamboo replacing plastic, bamboo replacing wood" a global green solution.'
                }
            },
            commitment: {
                title: 'Our Commitment:',
                content: 'Every bamboo is a symbiosis of nature and technology; every innovation is for the future of Earth and humanity.'
            }
        },
        cleanProduction: {
            title: 'Clean Production',
            subtitle: 'Guarding Green Mountains and Clear Waters with Innovative Technology, Leading Sustainable Development with Clean Production',
            description: 'As a green pioneer in the bamboo pulp and paper industry, Yibin Paper consistently practices the concept of "environmental protection first, green development", creating an efficient, clean, and sustainable modern paper industry through clean production processes, resource recycling, and low-carbon technology innovation, providing green paper solutions for global customers.',
            items: {
                raw: {
                    title: 'Green Raw Materials, Low-Carbon Source',
                    subtitle: '100% sustainable bamboo fiber, comprehensive utilization of production waste',
                    points: [
                        'Using fast-growing bamboo forest resources, reducing deforestation',
                        'Strong carbon sequestration capacity during bamboo growth, reducing carbon emissions from the source',
                        'Exploring comprehensive utilization of production waste such as bamboo chips and white mud, achieving efficient resource recycling'
                    ]
                },
                process: {
                    title: 'Clean Process, Energy Saving and Consumption Reduction',
                    subtitle: 'Low-pollution pulping technology, ultra-low emissions of wastewater and exhaust gas',
                    points: [
                        'Using advanced processes such as Elemental Chlorine Free (ECF) bleaching and oxygen delignification, significantly reducing harmful substance emissions like AOX (Adsorbable Organic Halides)',
                        'Achieving wastewater compliance through anaerobic + aerobic biological treatment technology combination, recycling intermediate water for raw material washing, reducing fresh water consumption',
                        'Equipped with alkali recovery furnace + electrostatic precipitator + wet desulfurization system, ensuring flue gas emissions better than national standards'
                    ]
                },
                recycle: {
                    title: 'Circular Economy, Turning Waste into Treasure',
                    subtitle: '100% black liquor recovery, sludge resource utilization, waste heat reuse',
                    points: [
                        'Converting pulping waste liquid into heat energy and chemicals through alkali recovery system, self-sufficiency rate over 85%, reducing fossil energy dependence',
                        'Using papermaking sludge for organic fertilizer or biomass fuel production, achieving "zero landfill" of solid waste',
                        'Using waste heat from production process for power generation, improving energy utilization efficiency'
                    ]
                },
                product: {
                    title: 'Green Products, Low-Carbon Life',
                    subtitle: 'Degradable packaging paper, FSC certified products',
                    points: [
                        'Bamboo fiber food-grade packaging paper, replacing plastic products, reducing "white pollution"',
                        'Ensuring paper sources comply with international forest sustainable management standards, meeting high-end market demands'
                    ]
                }
            }
        },
        circularEconomy: {
            title: 'Circular Economy',
            subtitle: 'Making the Most of Bamboo, Endless Cycle',
            imageAlt: 'Circular Economy Model Diagram',
            intro: {
                title: 'Bamboo Replacing Wood, Green Empowerment',
                content: 'As an advocate for efficient bamboo resource utilization, we have created a five-in-one circular economy model of "bamboo-pulp-paper-energy-fertilizer", allowing every bamboo to radiate green energy.'
            },
            items: {
                source: {
                    title: 'Green Starting Point: Sustainable Bamboo Source',
                    points: [
                        'Establishing ecological bamboo forest demonstration bases, adopting rotational cutting management mode.',
                        'Fast-growing bamboo (3-5 years to maturity), carbon sequestration capacity 1.5 times that of fir trees.',
                        'Helping 100,000 farmers increase income, transforming "green mountains and clear waters" into "gold and silver mountains".'
                    ]
                },
                core: {
                    title: 'Core Cycle: Zero Waste Emission',
                    points: [
                        'Waste liquid → Energy: 100% recovery of pulping black liquor, generating 60 million kWh annually.',
                        'Exhaust gas → Resources: Reuse of boiler flue gas waste heat, reducing CO2 emissions.',
                        'Waste residue → Carbon source: Bamboo chips made into biomass pellet fuel.'
                    ]
                },
                upgrade: {
                    title: 'Product Upgrade: Full Bamboo Utilization',
                    points: [
                        'High-grade bamboo pulp food packaging, household paper (FSC certified).',
                        'Bamboo fiber degradable packaging materials (plastic alternatives).',
                        'Bamboo chips and residues prepared into biomass waste.'
                    ]
                }
            },
            vision: {
                title: 'Our Vision:',
                content: 'Let every bamboo complete its green journey from carbon sink to product.'
            }
        },
        socialResponsibility: {
            title: "Social Responsibility",
            subtitle: "Silent Nurturing, Kindness to the World",
            tabs: {
                community: "Community Development",
                farmers: "Farmer Income Support",
                education: "Talent Training",
                biodiversity: "Environmentally Friendly"
            },
            community: {
                title: "Rural Revitalization Program",
                description: "Yibin Paper actively responds to the national rural revitalization strategy, driving the development of the bamboo industry in surrounding villages through the 'enterprise + cooperative + farmer' model, enhancing rural economic vitality.",
                items: {
                    village: {
                        title: "Village Assistance",
                        content: "The company has successively dispatched 2 party members to serve as the first village secretary in Shizi Village, Yongxing Town, Cuiping District, and 1 party member to Xingwang Village, Yangchun Town, Jiang'an County as a village work team member."
                    },
                    manager: {
                        title: "Collective Economy Professional Managers",
                        content1: "Two key talents have been sent to villages as 'professional managers' to manage village finances, standardize systems, expand markets, promote products, and cultivate business talents.",
                        content2: "Helping to improve the standardization, marketization, and specialization of the village collective economy."
                    },
                    project: {
                        title: "Xingwen County Dahe Miao Township Industry Development Cooperation Win-Win One-to-One Project",
                        content: "According to the requirements of the 'Yibin City Enterprise Contact Ethnic Township Cooperation Win-Win One-to-One Mechanism Operation Plan', the company is connected with Dahe Miao Township in Xingwen County to solve the problem of bamboo raw material sales."
                    }
                }
            },
            farmers: {
                title: "Farmer Income Support Project",
                description: "We have established stable cooperative relationships with local bamboo farmers. Through direct procurement, investment in intelligent equipment, and promotion of scientific breeding, we help bamboo farmers increase their income and achieve common prosperity.",
                imageAlt: "Farmer Income Support Project",
                items: {
                    direct: {
                        title: "Direct Procurement Eliminates Middlemen, Protects Farmers' Interests",
                        content1: "Breaking the traditional acquisition model, establishing various direct procurement models such as 'enterprise + specialized cooperative yard + farmer' and 'enterprise + self-built yard + farmer'.",
                        content2: "Strengthening deep cooperation between primary and secondary industries, eliminating middlemen, tapping cost potential in each link, ensuring raw material supply, facilitating bamboo sales for farmers, stabilizing bamboo prices, and protecting farmers' interests."
                    },
                    tech: {
                        title: "Technological Empowerment for Industrial Upgrading, Increasing Farmers' Income",
                        content1: "Increasing investment in intelligent equipment, focusing on bamboo harvesting and transportation, and developing machinery for harvesting and transporting bamboo.",
                        content2: "Comprehensively improving the efficiency of bamboo harvesting and transportation, completely freeing up labor, reducing harvesting costs, and sharing technological dividends with farmers to increase their income.",
                        content3: "Demonstrating high-yield bamboo forests through scientific breeding, planting, and management.",
                        content4: "Guiding farmers in scientific planting, reducing planting and management costs, increasing yield per mu, and increasing farmers' income from bamboo."
                    },
                    value: {
                        title: "Value-added Cooperation Expands Channels, Enhances Comprehensive Income",
                        content1: "Actively exploring diversified cooperation models, activating the 'non-timber income' of bamboo forests, piloting bamboo forest carbon sink trading with third-party institutions, and allowing farmers to receive additional dividends based on management effectiveness.",
                        content2: "At the same time, guiding the development of under-forest planting and breeding to enhance the comprehensive income of bamboo forests; combining under-forest economy with carbon sink management to enhance the carbon sequestration capacity of bamboo forests, increase farmers' income, and achieve a win-win situation for ecology and economy."
                    }
                }
            },
            education: {
                title: "Bamboo Talent Training Program",
                description: "Talent is the core engine driving development. We value talent cultivation and build a diversified talent training mechanism to nurture future industry talents.",
                imageAlt: "Talent Training Project",
                items: {
                    mechanism: {
                        title: "Diversified Talent Training Mechanism",
                        content: "Through mechanisms such as 'master-apprentice', reserve talent pool, job rotation practice, and customized training courses, we help employees transform from workplace newcomers to industry elites."
                    },
                    path: {
                        title: "Improved Development Path",
                        content: "Continuously improving promotion channels and diversified development paths, allowing every member to shine in their area of expertise and grow together with the company."
                    }
                }
            },
            biodiversity: {
                title: "Green Factory Program",
                description: "We actively respond to the national 'dual carbon' goal, take sustainable development as a strategic focus, and continuously optimize the environmental management system.",
                imageAlt: "Environmentally Friendly Project",
                items: {
                    policy: {
                        title: '"Bamboo Replaces Wood" "Bamboo Replaces Plastic"',
                        content: "Actively responding to the government's call for 'bamboo replaces wood' and 'bamboo replaces plastic' policies, reducing the impact of production on natural resources, transitioning to a low-carbon economy, and achieving a win-win situation for economic and environmental benefits."
                    },
                    factory: {
                        title: "Green Factory",
                        content: "Certified by FSCFM/CoC forest certification, rated as a national 'green factory' enterprise and Sichuan Province 'clean production' enterprise, and products have won the 'Sichuan Province Energy Conservation and Environmental Protection Brand Excellent Product Award'."
                    }
                }
            }
        },
        report: {
            title: 'Sustainability Report',
            subtitle: 'Transparent, Authentic, and Comprehensive Sustainability Information Disclosure',
            download: 'Download Report',
            items: {
                '2024': {
                    title: '2024 Sustainability Report',
                    date: 'Release Date: April 2024',
                    imageAlt: '2024 Sustainability Report'
                },
                '2023': {
                    title: '2023 Sustainability Report',
                    date: 'Release Date: April 2023',
                    imageAlt: '2023 Sustainability Report'
                }
            }
        },
        cta: {
            title: 'Join Us in Creating a Sustainable Future',
            description: 'Learn more about Yibin Paper\'s sustainable development practices, or partner with us to promote green development',
            buttonText: 'Contact Us'
        }
    },
    home: {
        advantages: {
            title: "Our Advantages",
            subtitle: "Bamboo Pulp Paper Making, Eco-friendly Technology, Excellent Quality",
            items: {
                experience: {
                    title: "Rich Industry Experience",
                    description: "80 years of technical accumulation, complete pulp and paper industry chain, providing solid technical support for green low-carbon bio-based material transformation."
                },
                production: {
                    title: "Mature Production System",
                    description: "Complete production facilities and automated production lines, capable of rapid response to customer needs, achieving low-cost and high-efficiency mass production."
                },
                innovation: {
                    title: "Industry-Academia-Research Innovation",
                    description: "Joint laboratories with universities and research institutions, focusing on low-carbon processes and renewable materials R&D, accelerating the industrialization of cutting-edge technologies like bio-based materials."
                },
                certification: {
                    title: "Complete Green Certification Chain",
                    description: "From raw material procurement to product production, certified by FSC, medical-grade products, and health safety products, enhancing product competitiveness."
                }
            }
        },
        products: {
            title: "Main Products",
            subtitle: "Premium Bamboo Pulp Paper Products for Diverse Needs",
            items: {
                bambooPulp: {
                    title: "Virgin Bamboo Pulp",
                    description: "Selected bamboo species, premium bamboo fiber",
                    alt: "Bamboo Pulp"
                },
                packagingPaper: {
                    title: "Virgin Bamboo Pulp Packaging Paper",
                    description: "High strength, excellent folding endurance, high cleanliness",
                    alt: "Packaging Paper"
                },
                culturalPaper: {
                    title: "Virgin Bamboo Pulp Cultural Paper",
                    description: "Smooth and delicate, excellent writing and printing experience",
                    alt: "Cultural Paper"
                },
                livingPaper: {
                    title: "Virgin Bamboo Pulp Living Base Paper",
                    description: "Wet strength, green and eco-friendly",
                    alt: "Living Base Paper"
                },
                finishedPaper: {
                    title: "Virgin Bamboo Pulp Living Finished Paper",
                    description: "Soft and comfortable, healthy and antibacterial",
                    alt: "Living Finished Paper"
                },
                fiberMaterial: {
                    title: "Fiber Material",
                    description: "Versatile functions, suitable for various special needs",
                    alt: "Fiber Material"
                },
                learnMore: "Learn More"
            },
        },
        about: {
            title: "About Yibin Paper",
            description1: "Founded in 1944, Yibin Paper Co., Ltd. is a leading bamboo pulp paper manufacturer in China, focusing on bamboo pulping and papermaking research and production.",
            description2: "Located in Yibin City, Sichuan Province, the company has abundant bamboo resources and advanced production equipment, with an annual capacity of over 500,000 tons of high-quality bamboo pulp paper.",
            description3: "We are committed to providing high-quality and environmentally friendly paper products through technological innovation and green production, while promoting sustainable development in the paper industry.",
            learnMore: "Learn More"
        },
        sustainability: {
            title: "Sustainable Development",
            subtitle: "Bamboo Pulp Paper Making, Green Cycle",
            items: {
                renewable: {
                    title: "Renewable Bamboo Source",
                    description: "Bamboo can be harvested in 3-5 years, grows rapidly, and is an ideal renewable raw material for papermaking"
                },
                carbon: {
                    title: "Carbon Sink Contribution",
                    description: "Bamboo forests absorb more CO₂ than forests of the same area, effectively mitigating climate change"
                },
                clean: {
                    title: "Clean Production",
                    description: "Adopting closed-loop production processes, wastewater treatment and reuse, achieving energy conservation and emission reduction"
                },
                rural: {
                    title: "Rural Revitalization",
                    description: "Promoting bamboo farmers' income growth, boosting local economic development, achieving win-win for ecology and economy"
                }
            }
        },
        cta: {
            title: "Partner with Us for a Green Future",
            description: "We look forward to providing you with quality bamboo pulp paper products and professional services",
            buttonText: "Contact Us"
        }
    },
    contact: {
        banner: {
            title: 'Contact Us',
            subtitle: 'We welcome your inquiries and feedback'
        },
        contactInfo: {
            title: 'Contact Information',
            subtitle: 'We welcome your inquiries and feedback',
            address: {
                title: 'Company Address',
                content: 'Peishi Light Industrial Park, Nanxi District, Yibin City, Sichuan Province',
                postcode: 'Postal Code: 644100'
            },
            phone: {
                title: 'Phone',
                main: 'Main: 0831-3309663',
                service: 'Customer Service: 0831-3309689'
            },
            email: {
                title: 'Email',
                service: 'Customer Service: ybzy@yb-zy.com',
                inquiry: 'Product Inquiry: ybzy@yb-zy.com'
            },
            workingHours: {
                title: 'Working Hours',
                weekday: 'Monday to Friday: 9:00 AM - 5:30 PM',
                holiday: 'Closed on holidays'
            }
        },
        inquiry: {
            title: 'Online Inquiry',
            subtitle: 'Fill out the form below and we will contact you soon',
            form: {
                name: 'Your Name',
                company: 'Company Name',
                email: 'Email',
                phone: 'Phone Number',
                subject: 'Inquiry Subject',
                subjectPlaceholder: 'Please select a subject',
                subjects: {
                    product: 'Product Inquiry',
                    price: 'Price Inquiry',
                    technical: 'Technical Support',
                    cooperation: 'Business Cooperation',
                    other: 'Other Questions'
                },
                message: 'Message',
                submit: 'Submit',
                submitting: 'Submitting...'
            },
            sales: {
                title: 'Sales Service',
                domestic: 'Domestic Sales',
                international: 'International Sales',
                email: 'Sales Email'
            },
            afterSales: {
                title: 'After-sales Service',
                hotline: 'Service Hotline',
                technical: 'Technical Support',
                email: 'Service Email'
            },
            social: {
                title: 'Follow Us',
                wechat: 'WeChat',
                weibo: 'Weibo',
                linkedin: 'LinkedIn'
            }
        },
        location: {
            title: 'Company Location',
            subtitle: 'Welcome to visit our company',
            mapAlt: 'Yibin Paper Industry Co., Ltd. Map Location',
            transport: {
                public: {
                    title: 'Public Transport',
                    content: 'Bus Routes: Take bus No. 15, 27, or 36 to "Paper Industry Station"'
                },
                driving: {
                    title: 'Driving Directions',
                    content: 'Navigate to "Yibin Paper Industry Co., Ltd." - Visitor parking available'
                },
                airport: {
                    title: 'Airport Transport',
                    content: 'Yibin Wuliangye Airport is about 30km away, accessible by airport shuttle or taxi'
                }
            }
        },
        offices: {
            title: 'Global Offices',
            subtitle: 'International Service Network',
            china: {
                title: 'China Headquarters',
                flagAlt: 'Chinese Flag',
                address: '159 Minjiang West Road, Cuiping District, Yibin City, Sichuan Province',
                phone: 'Tel: 0831-12345678'
            },
            usa: {
                title: 'North America Office',
                flagAlt: 'American Flag',
                address: '2588 Oak Avenue, Los Angeles, California, USA',
                phone: 'Tel: +1-213-888-9999'
            },
            japan: {
                title: 'Japan Office',
                flagAlt: 'Japanese Flag',
                address: '1-2-3 Marunouchi, Chiyoda-ku, Tokyo, Japan',
                phone: 'Tel: +81-3-1234-5678'
            },
            europe: {
                title: 'Europe Office',
                flagAlt: 'German Flag',
                address: '456 Hansa Street, Hamburg, Germany',
                phone: 'Tel: +49-40-8765-4321'
            },
            singapore: {
                title: 'Southeast Asia Office',
                flagAlt: 'Singapore Flag',
                address: '10 Raffles Quay, Singapore',
                phone: 'Tel: +65-6789-0123'
            }
        },
        faq: {
            title: 'Frequently Asked Questions',
            subtitle: 'Quick answers to your questions'
        },
        cta: {
            title: 'Looking Forward to Your Communication',
            description: 'Whatever questions or needs you have, we are here to serve you',
            buttonText: 'Contact Now'
        }
    }
} 